module.exports = __webpack_public_path__ + "img/huodng10.22cdd20b.png";